import React, { useState } from 'react'
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  Box,
  Tooltip,
  CircularProgress,
} from '@material-ui/core'
import { CloudDownload } from '@material-ui/icons'

const DownloadBamButton = ({ onClickConfirm, sampleName, downloadingBamId, bamId }) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleClickDownload = () => {
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleClickConfirm = () => {
    setDialogOpen(false)
    onClickConfirm()
  }

  return (
    <>
      <Tooltip title="Download BAM (+BAI)">
        <IconButton onClick={handleClickDownload} disabled={downloadingBamId === bamId}>
          {downloadingBamId === bamId ? <CircularProgress size={24} /> : <CloudDownload />}
        </IconButton>
      </Tooltip>
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Download BAM File</DialogTitle>
        <Box p={0.5} />
        <DialogContent>
          <DialogContentText>
            You are about to download the BAM file for sample: <strong>{sampleName}</strong>
          </DialogContentText>
          <DialogContentText>The download includes the BAM and its index (.bai) if available.</DialogContentText>
          <DialogContentText>
            Please ensure you have enough disk space as BAM files can be very large (often tens of GB).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleClickConfirm} autoFocus color="primary" variant="contained">
            Download
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DownloadBamButton
